import { STORE_DEATILS_ACTION } from 'core/constants/Actions';
import { Action } from 'core/models/ActionTypes'
import { Store } from 'core/models/Store';

const intialState: { store: Store | null, isLoading: boolean } = {
  store: null,
  isLoading: false
}

interface ActionType extends Action {
  payload: {
    store: Store;
  }
}

export default function storeDetailsReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case STORE_DEATILS_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case STORE_DEATILS_ACTION.SUCCESS:
      const { store } = action.payload;
      return { ...state, store, isLoading: false }

    case STORE_DEATILS_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}